/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LocoDetail } from '../../../core/model/loco-detail.model';
import { Tab } from '../../../core/model/tab.model';
import { AppUtilityService } from '../../../core/services/app-utility.service';


/**
 * @export
 * @class LmsLocoFuelComponent
 * @implements {OnInit}
 * @implements{OnDestroy}
 */
@Component({
    selector: 'lms-loco-fuel',
    templateUrl: './lms-loco-fuel.component.html',
    styleUrls: ['./lms-loco-fuel.component.scss']
})
export class LmsLocoFuelComponent implements OnInit, OnDestroy, OnChanges {

    @Input() locoData: LocoDetail;
    @Input() locoLabel: any;
    @Input() tab: Tab;
    @Input() group: any;
    @Input() errorMap: Map<string, boolean>;
    public locoFuelForm: UntypedFormGroup;

    /**
     * Creates an instance of LmsLocoFuelComponent.
     * @param {AppUtilityService} appUtilityService
     *
     * @memberOf LmsLocoFuelComponent
     */
    constructor(private appUtilityService: AppUtilityService) { }

    /**
     * @memberOf LmsLocoFuelComponent
     */
    ngOnInit() {
    }

    /**
     * @memberOf LmsLocoFuelComponent
     */
    ngOnChanges() {
        if (this.tab.mode === 'edit') {
            this.locoFuelForm = this.group;
        }
    }

    /**
     * @memberOf LmsLocoFuelComponent
     */
    ngOnDestroy() {
    }
    /**
     * This method returns dash only when all the values given are null or blank
     * @param {string[]} value
     * @returns
     * @memberOf LmsLocoFuelComponent
     */
    returnDash(value: string[]) {
        let isBlank: boolean;
        for (let i = 0; i < value.length; i++) {
            if (value[i]) {
                isBlank = false;
                break;
            } else {
                isBlank = true;
            }
        }
        return isBlank;
    }


    /**
     * Check Fuel Level Source
     * @param {string} value
     * @returns {string}
     * @memberOf LmsLocoFuelComponent
     */
    isFuelLevelSourcePresent(value: string): string {
        let fuelSource = '';
        if (!value || '' === value) {
            fuelSource = '';
        } else {
            fuelSource = `(${value})`;
        }
        return fuelSource;
    }
}
